module.exports = __webpack_public_path__ + "04_short_grey.145eb3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_short_grey.png
// module id = 5BaX
// module chunks = 0